export enum ClaimCommodityLineItemMaxLengths {
  Weight = 6,
  Pieces = 9,
  Description = 450,
  ClassCd = 5,
  WeightWithDecimal = 8,
}
